import { type IEvent, filterFacebookEvents } from '@audacy-clients/core/utils/facebook';

export const sendEventsToFacebook = (events: IEvent[]): void => {
  const matchingEvents = filterFacebookEvents(events);

  // biome-ignore lint/complexity/noForEach: This is a simple object iteration
  matchingEvents.forEach((event) => {
    window.fbq('trackCustom', event.type, event);
  });
};
